<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
#app {
  font-family: 'PingFangSC-Regular','Avenir', Helvetica, Arial, sans-serif;
}
</style>



// WEBPACK FOOTER //
// src/App.vue